import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fulltext-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class FulltextNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
